import http from '@gp/utils/httpTS';
import { GrossRevenueDataType } from '../types/services';

export const fetchStudioGrossRevenueData = (params: {
  'select_id': string[],
  'start_date': string,
  'end_date': string,
  'yoy': boolean,
  'mom': boolean,
  'order'?: 'asc' | 'desc',
  'order_metric'?: string,
}): Promise<GrossRevenueDataType> => {
  return http.post('/api/v1/globalpedia_pc/gross_revenue_trends/studio_gross_revenue', params);
};

export const studioGrossRevenueDownLoad = (params: {
  'file_type': 1 | 2, // 1: csv 2: excal
  'select_id': string[],
  'start_date': string,
  'end_date': string,
  'yoy': boolean,
  'mom': boolean,
  'order'?: 'asc' | 'desc',
  'order_metric'?: string,
}) => {
  // @ts-ignore
  return http({
    url: '/api/v1/globalpedia_pc/gross_revenue_trends/studio_gross_revenue/download',
    method: 'post',
    data: params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
  });
};

export const fetchProjectGrossRevenueData = (params: {
  'select_id': string[],
  'start_date': string,
  'end_date': string,
  'yoy': boolean,
  'mom': boolean,
  'order'?: 'asc' | 'desc',
  'order_metric'?: string,
}): Promise<GrossRevenueDataType> => {
  return http.post('/api/v1/globalpedia_pc/gross_revenue_trends/project_gross_revenue', params);
};

export const projectGrossRevenueDownLoad = (params: {
  'file_type': 1 | 2, // 1: csv 2: excal
  'select_id': string[],
  'start_date': string,
  'end_date': string,
  'yoy': boolean,
  'mom': boolean,
  'order'?: 'asc' | 'desc',
  'order_metric'?: string,
}) => {
  // @ts-ignore
  return http({
    url: '/api/v1/globalpedia_pc/gross_revenue_trends/project_gross_revenue/download',
    method: 'post',
    data: params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
  });
};
